import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrial: ITrialLoadActionCreator = () => {
        return {
            type: ACTION_TRIALS_LOAD
        }
    },
    LoadTrialById: ITrialLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALS_LOAD_BY_ID,
            id,
        }
    },
    LoadSuccess: ITrialLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALS_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALS_LOAD_FAILURE,
            responseStatus
        }
    },


    SaveTrial: ITrialSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALS_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALS_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALS_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrial: ITrialCreateActionCreator = () => {

        return {
            type: ACTION_TRIALS_CREATE
        }
    },
    CreateSuccess: ITrialCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALS_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALS_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateTrial: ITrialValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALS_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALS_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALS_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALS_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALS_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALS_LOAD = "ACTION_TRIALS_LOAD",
    ACTION_TRIALS_LOAD_BY_ID = "ACTION_TRIALS_LOAD_BY_ID",
    ACTION_TRIALS_LOAD_SUCCESS = "ACTION_TRIALS_LOAD_SUCCESS",
    ACTION_TRIALS_LOAD_FAILURE = "ACTION_TRIALS_LOAD_FAILURE",

    ACTION_TRIALS_SAVE = "ACTION_TRIALS_SAVE",
    ACTION_TRIALS_SAVE_SUCCESS = "ACTION_TRIALS_SAVE_SUCCESS",
    ACTION_TRIALS_SAVE_FAILURE = "ACTION_TRIALS_SAVE_FAILURE",

    ACTION_TRIALS_CREATE = "ACTION_TRIALS_CREATE",
    ACTION_TRIALS_CREATE_SUCCESS = "ACTION_TRIALS_CREATE_SUCCESS",
    ACTION_TRIALS_CREATE_FAILURE = "ACTION_TRIALS_CREATE_FAILURE",

    ACTION_TRIALS_VALIDATE = "ACTION_TRIALS_VALIDATE",
    ACTION_TRIALS_VALIDATE_SUCCESS = "ACTION_TRIALS_VALIDATE_SUCCESS",
    ACTION_TRIALS_VALIDATE_FAILURE = "ACTION_TRIALS_VALIDATE_FAILURE",

    ACTION_TRIALS_CLEAR = "ACTION_TRIALS_CLEAR",

    ACTION_TRIALS_FILTER = "ACTION_TRIALS_FILTER";

export interface ITrialLoadAction {
    type: "ACTION_TRIALS_LOAD";
}

export interface ITrialLoadActionCreator {
    (): ITrialLoadAction;
}

export interface ITrialLoadSuccessAction {
    type: "ACTION_TRIALS_LOAD_SUCCESS";
    formData: Dtos.Trial | Dtos.Trial[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialLoadSuccessActionCreator {
    (
        formData: Dtos.Trial | Dtos.Trial[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialLoadSuccessAction;
}

export interface ITrialLoadFailureAction {
    type: "ACTION_TRIALS_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialLoadFailureAction;
}

export interface ITrialLoadByIdAction {
    type: "ACTION_TRIALS_LOAD_BY_ID";
    id: number;
}

export interface ITrialLoadByIdActionCreator {
    (id: number): ITrialLoadByIdAction;
}

export interface ITrialSaveAction {
    type: "ACTION_TRIALS_SAVE";
    formData: Dtos.Trial;

}

export interface ITrialSaveActionCreator {
    (
        formData: Dtos.Trial
    ): ITrialSaveAction;
}

export interface ITrialSaveSuccessAction {
    type: "ACTION_TRIALS_SAVE_SUCCESS";
    formData: Dtos.Trial;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialSaveSuccessActionCreator {
    (
        formData: Dtos.Trial,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialSaveSuccessAction;
}

export interface ITrialSaveFailureAction {
    type: "ACTION_TRIALS_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialSaveFailureAction;
}

export interface ITrialCreateAction {
    type: "ACTION_TRIALS_CREATE"
}

export interface ITrialCreateActionCreator {
    (): ITrialCreateAction
}

export interface ITrialCreateSuccessAction {
    type: "ACTION_TRIALS_CREATE_SUCCESS";
    formData: Dtos.Trial;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ITrialCreateSuccessActionCreator {
    (
        formData: Dtos.Trial,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialCreateSuccessAction;
}

export interface ITrialCreateFailureAction {
    type: "ACTION_TRIALS_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialCreateFailureAction;
}

export interface ITrialValidateAction {
    type: "ACTION_TRIALS_VALIDATE";
    formData: Dtos.Trial;

}

export interface ITrialValidateActionCreator {
    (
        formData: Dtos.Trial
    ): ITrialValidateAction;
}

export interface ITrialValidateSuccessAction {
    type: "ACTION_TRIALS_VALIDATE_SUCCESS";
    formData: Dtos.Trial;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialValidateSuccessActionCreator {
    (
        formData: Dtos.Trial,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialValidateSuccessAction;
}

export interface ITrialValidateFailureAction {
    type: "ACTION_TRIALS_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialValidateFailureAction;
}

export interface ITrialClearAction {
    type: "ACTION_TRIALS_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialClearActionCreator {
    (propertiesToClear?: string[]): ITrialClearAction;
}

export interface ITrialFilterActionCreator {
    (formFilter: IFormFilter): ITrialFilterAction;
}

export interface ITrialFilterAction {
    type: "ACTION_TRIALS_FILTER";
    formFilter: IFormFilter;
}

export type TrialAction =
    ITrialLoadAction |
    ITrialLoadByIdAction |
    ITrialLoadFailureAction |
    ITrialLoadSuccessAction |
    ITrialSaveAction |
    ITrialSaveSuccessAction |
    ITrialSaveFailureAction |
    ITrialCreateAction |
    ITrialCreateSuccessAction |
    ITrialCreateFailureAction |
    ITrialValidateAction |
    ITrialValidateSuccessAction |
    ITrialValidateFailureAction |
    ITrialClearAction |
    ITrialFilterAction;